import { LeaveTypeListTable } from '../components/LeaveTypeListTable';

export function LeaveTypeListPage() {
  return <LeaveTypeListTable />;
}
